// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopularAuthor_containerMain__9zHOm{
    background-color: #1a1a1a;

}
.PopularAuthor_container__8WaxN {
    max-width: 95%;
    margin: 0 auto;
  }
  
  .PopularAuthor_author__vGkBa {
    width: 100%;
  }
  
  .PopularAuthor_heading__qBpZq {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 1rem;
    color: white;
  }
  
  .PopularAuthor_swiper__352Gi {
    padding: 0rem 0rem;
    padding-bottom: 0rem; /* Space for pagination */
  }
  
  .PopularAuthor_swiperSlide__JQxwB {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .PopularAuthor_authorCard__SxrNO {
    background:black;
    border-radius: 10px;
    padding: 1rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    width: 100%;
    text-align: center;
  }
  
  .PopularAuthor_authorCard__SxrNO:hover {
    transform: translateY(-5px);
  }
  
  .PopularAuthor_imageWrapper__celDI {
    width: 100%;
    height: 200px;
    border-radius: 15px;
    margin: 0 auto 1rem;
    overflow: hidden;
  }
  
  .PopularAuthor_authorImage__ArYJP {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .PopularAuthor_authorName__pNsXW {
    font-size: 1.2rem;
    font-weight: 600;
    margin: 0;
    color: white;
  }
  
  /* Custom Swiper navigation styles */
  .swiper-button-next,
  .swiper-button-prev {
    color: #333;
  }
  
  .swiper-pagination-bullet {
    background: #333;
  }
  
  .swiper-pagination-bullet-active {
    background: #000;
  }
  
  /* Responsive styles */
  @media (max-width: 768px) {
    .PopularAuthor_container__8WaxN {
      padding: 0px;
    }
    
    .PopularAuthor_heading__qBpZq {
      font-size: 18px;
      margin-bottom: 0.5rem;
    }
    
    .PopularAuthor_imageWrapper__celDI {
      width: 120px;
      height: 120px;
    }
    
    .PopularAuthor_authorName__pNsXW {
      font-size: 1rem;
    }
  }
  
  @media (max-width: 480px) {
    .PopularAuthor_imageWrapper__celDI {
      width: 100px;
      height: 100px;
    }
    .PopularAuthor_heading__qBpZq {
      font-size: 1.2rem;
      margin-top: 0.5rem;
     }
  }`, "",{"version":3,"sources":["webpack://./src/pages/reading-pages/components/Css/PopularAuthor.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;;AAE7B;AACA;IACI,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,oBAAoB,EAAE,yBAAyB;EACjD;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,YAAY;EACd;;EAEA,oCAAoC;EACpC;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE;MACE,YAAY;IACd;;IAEA;MACE,eAAe;MACf,qBAAqB;IACvB;;IAEA;MACE,YAAY;MACZ,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,YAAY;MACZ,aAAa;IACf;IACA;MACE,iBAAiB;MACjB,kBAAkB;KACnB;EACH","sourcesContent":[".containerMain{\n    background-color: #1a1a1a;\n\n}\n.container {\n    max-width: 95%;\n    margin: 0 auto;\n  }\n  \n  .author {\n    width: 100%;\n  }\n  \n  .heading {\n    font-size: 20px;\n    font-weight: bold;\n    margin-bottom: 1rem;\n    color: white;\n  }\n  \n  .swiper {\n    padding: 0rem 0rem;\n    padding-bottom: 0rem; /* Space for pagination */\n  }\n  \n  .swiperSlide {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .authorCard {\n    background:black;\n    border-radius: 10px;\n    padding: 1rem;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease;\n    width: 100%;\n    text-align: center;\n  }\n  \n  .authorCard:hover {\n    transform: translateY(-5px);\n  }\n  \n  .imageWrapper {\n    width: 100%;\n    height: 200px;\n    border-radius: 15px;\n    margin: 0 auto 1rem;\n    overflow: hidden;\n  }\n  \n  .authorImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .authorName {\n    font-size: 1.2rem;\n    font-weight: 600;\n    margin: 0;\n    color: white;\n  }\n  \n  /* Custom Swiper navigation styles */\n  :global(.swiper-button-next),\n  :global(.swiper-button-prev) {\n    color: #333;\n  }\n  \n  :global(.swiper-pagination-bullet) {\n    background: #333;\n  }\n  \n  :global(.swiper-pagination-bullet-active) {\n    background: #000;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 768px) {\n    .container {\n      padding: 0px;\n    }\n    \n    .heading {\n      font-size: 18px;\n      margin-bottom: 0.5rem;\n    }\n    \n    .imageWrapper {\n      width: 120px;\n      height: 120px;\n    }\n    \n    .authorName {\n      font-size: 1rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .imageWrapper {\n      width: 100px;\n      height: 100px;\n    }\n    .heading {\n      font-size: 1.2rem;\n      margin-top: 0.5rem;\n     }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerMain": `PopularAuthor_containerMain__9zHOm`,
	"container": `PopularAuthor_container__8WaxN`,
	"author": `PopularAuthor_author__vGkBa`,
	"heading": `PopularAuthor_heading__qBpZq`,
	"swiper": `PopularAuthor_swiper__352Gi`,
	"swiperSlide": `PopularAuthor_swiperSlide__JQxwB`,
	"authorCard": `PopularAuthor_authorCard__SxrNO`,
	"imageWrapper": `PopularAuthor_imageWrapper__celDI`,
	"authorImage": `PopularAuthor_authorImage__ArYJP`,
	"authorName": `PopularAuthor_authorName__pNsXW`
};
export default ___CSS_LOADER_EXPORT___;
